import React, { useState, useEffect } from 'react';
import { reachService } from '../../../services/reachService';
import CityTabs from './CityTabs';
import TransportAccordion from './TransportAccordion';
import locationQr from '../../../assets/images/location-qr.png';

const HowToReach = () => {
  const [cities, setCities]       = useState([]);
  const [loading, setLoading]     = useState(true);
  const [activeCityId, setActive] = useState(null);

  useEffect(() => {
    reachService.getCities()
      .then(res => {
        const data = res.data.cities || [];
        setCities(data);
        if (data.length > 0) setActive(data[0].id);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || cities.length === 0) return null;

  const activeCity = cities.find(c => c.id === activeCityId);

  return (
    <section
      id="how-to-reach"
      aria-labelledby="htr-heading"
      style={{
        padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 48px)',
        backgroundColor: '#f9fafb',
      }}
    >
      {/* Section heading */}
      <div style={{ textAlign: 'center', marginBottom: 36 }}>
        <h2
          id="htr-heading"
          style={{
            fontSize: 'clamp(28px, 4vw, 40px)',
            fontWeight: 900,
            color: '#1f2937',
            fontFamily: "'Playfair Display', serif",
            marginBottom: 12,
          }}
        >
          How to Reach Us
        </h2>
        <p style={{ fontSize: 16, color: '#6b7280', maxWidth: 560, margin: '0 auto' }}>
          Travelling to Burans Hikes, Dhanaulti? Pick your departure city and
          choose the most convenient route.
        </p>
      </div>

      {/* City tabs */}
      <div style={{ maxWidth: 760, margin: '0 auto 28px' }}>
        <CityTabs
          cities={cities}
          activeId={activeCityId}
          onSelect={setActive}
        />
      </div>

      {/* Transport accordion for active city */}
      {activeCity && (
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <TransportAccordion
            transports={activeCity.transports}
            citySlug={activeCity.city_slug}
          />
        </div>
      )}

      {/* Find Us — map + QR */}
      <div style={{ maxWidth: 1000, margin: '56px auto 0' }}>
        {/* pill label */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #16a34a, #15803d)',
            color: '#fff',
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            padding: '6px 22px',
            borderRadius: 9999,
          }}>Find Us</span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'stretch' }}>
          {/* Map */}
          <div style={{
            flex: '1 1 460px',
            borderRadius: 20,
            overflow: 'hidden',
            boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
            minHeight: 360,
          }}>
            <iframe
              title="Burans Hikes location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3441.096816051585!2d78.23079937612283!3d30.404994901397053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3908df832df12c43%3A0x5e23a2aba0682be3!2sBurans%20Hikes%20Home%20Stay%20(Resort)!5e0!3m2!1sen!2sin!4v1781382293190!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block', minHeight: 360 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* QR card */}
          <div style={{
            flex: '0 1 240px',
            minWidth: 220,
            background: '#fff',
            borderRadius: 20,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '36px 28px',
            gap: 18,
            textAlign: 'center',
          }}>
            {/* green icon */}
            <div style={{
              width: 52,
              height: 52,
              background: 'linear-gradient(135deg, #16a34a, #15803d)',
              borderRadius: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 14px rgba(22,163,74,0.35)',
            }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle cx="12" cy="9" r="2.5"/>
              </svg>
            </div>

            {/* text */}
            <div>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#1f2937', margin: '0 0 6px' }}>
                Navigate with QR
              </p>
              <p style={{ fontSize: 13, color: '#6b7280', margin: 0, lineHeight: 1.5 }}>
                Burans Hikes<br />Dhanaulti, Uttarakhand
              </p>
            </div>

            {/* QR image */}
            <img
              src={locationQr}
              alt="Scan QR code to open Burans Hikes on Google Maps"
              style={{
                width: 160,
                height: 160,
                borderRadius: 14,
                border: '3px solid #f3f4f6',
                boxShadow: '0 2px 10px rgba(0,0,0,0.10)',
              }}
            />

            <p style={{ fontSize: 12, color: '#9ca3af', margin: 0, letterSpacing: '0.02em' }}>
              Scan to open in Google Maps
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToReach;
